import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
          <div className="footer-brand">
            <img className="footer-logo" src="/NLW-logo.png" alt="Next Level Websites" />
            <p>We build websites tailored and crafted to your business's needs, customized to your liking.</p>
          </div>

          <div className="footer-col">
            <h5>Pages</h5>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/packages">Packages</Link></li>
              <li><Link to="/get-started">Get Started</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>Legal</h5>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>Contact</h5>
            <ul>
              <li><a href="mailto:nextlvlwebsites@gmail.com">nextlvlwebsites@gmail.com</a></li>
              <li><a href="tel:+18603289455">(860) 328-9455</a></li>
              <li>
                <a href="http://instagram.com/nextlvlwebsites" target="_blank" rel="noopener noreferrer">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

      <div className="footer-bottom">
        <span>&copy; {new Date().getFullYear()} Next Level Websites. All rights reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;
